var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#FF3000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2249 7.48583C17.8147 7.6451 18.2783 8.10983 18.435 8.69892C18.72 9.76801 18.72 12 18.72 12C18.72 12 18.72 14.232 18.435 15.3011C18.2761 15.8924 17.8125 16.3571 17.2249 16.5142C16.1586 16.8 11.88 16.8 11.88 16.8C11.88 16.8 7.60368 16.8 6.53513 16.5142C5.94537 16.3549 5.48182 15.8902 5.32513 15.3011C5.04004 14.232 5.04004 12 5.04004 12C5.04004 12 5.04004 9.76801 5.32513 8.69892C5.484 8.10765 5.94754 7.64292 6.53513 7.48583C7.60368 7.20001 11.88 7.20001 11.88 7.20001C11.88 7.20001 16.1586 7.20001 17.2249 7.48583ZM14.0672 12L10.5133 14.0575V9.94256L14.0672 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.823b02bdb7c65e95f584645a9b20fd11.svg";
export { ForwardRef as ReactComponent };